import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { GlobalWarmingPageComponent } from './components/page/global-warming-page.component';
import { GlobalWarmingRoutingModule } from './global-warming-routing.module';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
	  GlobalWarmingPageComponent,
  ],
  imports: [
    CommonModule,
    GlobalWarmingRoutingModule,
    MatIconModule,
    SharedModule,
    NgOptimizedImage
  ],
})
export class GlobalWarmingModule { }
